import React, { useEffect, useState } from 'react'
import RED_ROOM from './img'
import { useTranslation } from 'react-i18next'

const OutroRoom = ({ show }) => {
  const { i18n } = useTranslation()
  const lng = i18n.language
  const { background, ua, en, bgThumbnail } = RED_ROOM
  let slides = lng === 'uk' ? ua : en

  const [loadImgsCount, setLoadImgsCount] = useState(0)

  useEffect(() => {
    const arr = [new Image(), new Image(), new Image(), new Image(), new Image(), new Image(), new Image()]
    arr.forEach((img) => {
      img.onload = () => {
        setLoadImgsCount((prev) => prev + 1)
      }
    })
    slides.map((sl, i) => (arr[i].src = sl))
  }, [slides])

  const [counter, setCounter] = useState(0)
  const [toggle, setToggle] = useState(false)

  useEffect(() => {
    if (counter === slides.length) {
      setCounter(0)
    }
  }, [counter])

  useEffect(() => {
    if (loadImgsCount === 4) {
      setTimeout(() => setToggle(true), 3000)
    }
  }, [loadImgsCount])

  useEffect(() => {
    if (!toggle && loadImgsCount > 4) {
      let id = setTimeout(() => {
        setToggle(true)
      }, 3000)
      return () => clearTimeout(id)
    }
  }, [toggle, loadImgsCount])

  useEffect(() => {
    if (toggle) {
      let id = setTimeout(() => {
        setCounter((prev) => prev + 1)
        setToggle(false)
      }, 6000)
      return () => clearTimeout(id)
    }
  }, [toggle])

  return (
    <Slide img={background} show={show} className="bgContainer">
      <div
        className="thumbnail"
        style={{
          backgroundImage: `url(${bgThumbnail})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          height: '100vh',
          width: '100vw',
        }}
      />
      <Slide img={toggle && slides[counter]} />
    </Slide>
  )
}

export default OutroRoom

const Slide = ({ img, children, show, className }) => {
  return (
    <div
      className={className}
      style={{
        // opacity: show ? 1 : 0,
        height: '100vh',
        width: '100vw',
        zIndex: 2,
        backgroundImage: `url(${img})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
      }}
    >
      {children}
    </div>
  )
}
